<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-dialog-title mat-dialog-title>
  {{ data.title }}
</ngf-dialog-title>

<mat-dialog-content>
  <div class="modal-message">
    @if (data?.messageAsHtml) {
      <p [innerHTML]="data.message"></p>
    }
    @if (!data?.messageAsHtml) {
      <p class="preserve-whitespace">{{ data.message }}</p>
    }

    @if (data?.errorId) {
      <p id="error-id">Error ID: {{data?.errorId}}</p>
    }
    @if (data?.errorId) {
      <p>Error occurred at: {{ currentDate | date:'MMM dd yyyy HH:mm:ss a' : 'UTC'}} UTC</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button ngfButton="primary" mat-dialog-close>OK</button>
</mat-dialog-actions>
